<template>
	<section class="marquee withdraw-wrappwer wallet_page_container">
		<div class="container">
			<div class="with-full deposit-outer">
				<div class="back-btn p-al flex-box">
					<a @click="$router.back()" class="back-btn-lef">
                        <img src="@/assets/images/left-arrow-bg.webp" alt="left-arrow" loading="lazy" />
                        {{ $t('back', 'Back') }}
                    </a>
                    <span class="bank-deps p-0">{{ $t('transaction-history', 'Transaction History') }}</span>
					<div class="history-list">
                        <img src="@/assets/images/transaction.webp" alt="transaction" loading="lazy" />
                    </div>
				</div>
				<div class="withdraw-detail">
					<div class="deposit-outer-body b-acc pt-0">
						<div class="game-sec pass-form mess-inner border-0">
							<div class="calender current-past-data">
								<nav>
									<div class="nav nav-tabs" id="nav-tab" role="tablist">
										<button class="nav-link active" id="nav-Current-tab" data-bs-toggle="tab" data-bs-target="#nav-Current" 
                                            @click="updateSelectedType('all')" type="button" role="tab" aria-controls="nav-Current" aria-selected="true">
                                            {{ $t('all', 'ALL') }}
                                        </button>
										<button class="nav-link" id="nav-Past-tab" data-bs-toggle="tab" data-bs-target="#nav-Past" type="button" 
                                            @click="updateSelectedType('w')" role="tab" aria-controls="nav-Past" aria-selected="false">
                                            {{ $t('withdraw', 'WITHDRAW') }}
                                        </button>
										<button class="nav-link" id="nav-Past-two-tab" data-bs-toggle="tab" data-bs-target="#nav-Past-two" type="button" 
                                            @click="updateSelectedType('d')" role="tab" aria-controls="nav-Past-two" aria-selected="false">
                                            {{ $t('deposit', 'DEPOSIT') }}
                                        </button>
									</div>
								</nav>
                                
                                <div class="filter-section pb-2">
                                    <div class="filter-section-calender">
                                        <div class="fsc-group history_fsc_wrap">
                                            <label class="yol-label">from</label>
                                            <div class="react-datepicker-wrapper">
                                                <input type="date" id="fromDate" v-model="formDates.fromDate" @input="preventClearFromDate" class="form-control date-field" />
                                            </div>
                                            <span class="fsc-group-icon"><svg fill="none" viewBox="0 0 12 14"><path d="M9.894 2.61H1.855c-.634 0-1.148.514-1.148 1.148v8.038c0 .635.514 1.149 1.148 1.149h8.039c.634 0 1.148-.514 1.148-1.149V3.758c0-.634-.514-1.149-1.148-1.149ZM8.172 1.461v2.297M3.578 1.461v2.297M.707 6.055h10.335" stroke="#4F6380" stroke-width="1.148" stroke-linecap="round" stroke-linejoin="round"></path><path fill="#4F6380" d="M2.566 7.844H3.96v1.268H2.566zM2.566 9.936H3.96v1.268H2.566zM4.484 7.844h1.394v1.268H4.484zM4.484 9.936h1.394v1.268H4.484zM6.398 7.844h1.394v1.268H6.398zM6.398 9.936h1.394v1.268H6.398zM8.313 7.844h1.394v1.268H8.313zM8.313 9.936h1.394v1.268H8.313z"></path></svg></span>
                                        </div>
                                        <div class="fsc-group history_fsc_wrap">
                                            <label class="yol-label">To</label>
                                            <div class="react-datepicker-wrapper">
                                                <input type="date" id="toDate"  v-model="formDates.toDate" @input="preventClearToDate" class="form-control date-field" />
                                            </div>
                                            <span class="fsc-group-icon"><svg fill="none" viewBox="0 0 12 14"><path d="M9.894 2.61H1.855c-.634 0-1.148.514-1.148 1.148v8.038c0 .635.514 1.149 1.148 1.149h8.039c.634 0 1.148-.514 1.148-1.149V3.758c0-.634-.514-1.149-1.148-1.149ZM8.172 1.461v2.297M3.578 1.461v2.297M.707 6.055h10.335" stroke="#4F6380" stroke-width="1.148" stroke-linecap="round" stroke-linejoin="round"></path><path fill="#4F6380" d="M2.566 7.844H3.96v1.268H2.566zM2.566 9.936H3.96v1.268H2.566zM4.484 7.844h1.394v1.268H4.484zM4.484 9.936h1.394v1.268H4.484zM6.398 7.844h1.394v1.268H6.398zM6.398 9.936h1.394v1.268H6.398zM8.313 7.844h1.394v1.268H8.313zM8.313 9.936h1.394v1.268H8.313z"></path></svg></span>
                                        </div>
                                    </div>
                                   <div class="history_selct_box">
                                        <select class="form-select form-control mb-2" v-model="selectedStatus">
                                            <option v-for="(item, index) in options" :key="index" :value="item.value">{{ item.label }}</option>
                                        </select>
                                        <button type="button"  @click="getWalletHistory()" role="tab" aria-controls="nav-Past-two" aria-selected="false">
                                            Submit
                                        </button>
                                   </div>
                                </div>
                                <div class="history-wrap" v-if="filteredWalletHistoryList && filteredWalletHistoryList.length > 0">
                                    <div class="history-items" v-for="(item,index) in filteredWalletHistoryList" :key="index">
                                        <div class="history-sub-item">
                                            <span class="history-key">{{ $t('requested-amount', 'Requested Amount') }}</span>
                                            <span class="double_dots_width">:</span>
                                            <span class="history-value">{{ item?.amount }}</span>
                                        </div>
                                        <div class="history-sub-item">
                                            <span class="history-key">{{ $t('approved-amount', 'Approved amount') }}</span>
                                            <span class="double_dots_width">:</span>
                                            <span class="history-value">{{ item?.approved_amount || '-' }}</span>
                                        </div>
                                        <div class="history-sub-item">
                                            <span class="history-key">{{ $t('request-date', 'Request Date') }}</span>
                                            <span class="double_dots_width">:</span>
                                            <span class="history-value">{{ $dateTime.getLocalDate(item?.created_at, "DD/MM/YYYY hh:mm:ss A") }}</span>
                                        </div>
                                        <div class="history-sub-item" v-if="!(item.status === 0 || item.status === 4)">
                                            <span class="history-key">{{ $t('action-on', 'Action on') }}</span>
                                            <span class="double_dots_width">:</span>
                                            <span class="history-value" v-if="item.status == 'pending'">-</span>
                                            <span class="history-value" v-else-if="item.status == 'hold'">{{ item?.hold_at ? $dateTime.getLocalDate(item?.hold_at, 'DD/MM/YYYY hh:mm:ss A') : '-'}}</span>
                                            <span class="history-value" v-else>{{ item?.action_at ? $dateTime.getLocalDate(item?.action_at, 'DD/MM/YYYY hh:mm:ss A') : '-'}}</span>
                                        </div>
                                        
                                        <div class="history-sub-item">
                                            <span class="history-key">Payment Type</span>
                                            <span class="double_dots_width">:</span>
                                            <span class="history-value">{{toTitleCaseWithSpaces(item?.type)}}</span>
                                        </div>
                                        <div class="history-sub-item">
                                            <span class="history-key">Payment Method</span>
                                            <span class="double_dots_width">:</span>
                                            <span class="history-value">{{item?.payment_method || '-'}}</span>
                                        </div>
                                        <div class="history-sub-item">
                                            <span class="history-key">{{ $t('remark', 'Remarks') }}</span>
                                            <span class="double_dots_width">:</span>
                                            <span class="history-value">{{item.remark || '-'}}</span>
                                        </div>
                                        <div class="history-sub-item">
                                            <span class="history-key">{{ $t('transaction-no', 'Transaction No') }}</span>
                                            <span class="double_dots_width">:</span>
                                            <span class="history-value">{{ item?.transaction_id ?? '-' }}</span>
                                        </div>
                                        <div class="history-sub-item">
                                            <span class="history-key" >Status</span>
                                            <span class="double_dots_width">:</span>
                                            <span class="history-value">
                                                <span :class="getTransactionStatus(item.status).class">
                                                    {{ getTransactionStatus(item.status).label }} 
                                                    <button type="button" class="refresh_btn" @click="getWalletHistory(item)" v-if="['pending', 'approve_in_process', 'reject_in_process','hold'].includes(item.status)">
                                                        <img src = "@/assets/images/sync.png" :class="['fa', 'fa-refresh', {'fa-spin': selectedRequest?.c_a_tid == item?.c_a_tid ? spinClass : false}]" alt="refresh" loading="lazy"/>
                                                    </button>
                                                </span>
                                                <span class="transactionModal" @click="transactionalDetails(item)" v-if="item?.transaction_image_url" data-bs-toggle="modal" data-bs-target="#transactionModal">{{ $t('view-details','View details') }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <NoDataFound v-else-if="!loading"></NoDataFound>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
    <div class="modal fade bonus-point-modal history-filter-modal transaction_detail_modal" id="transactionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
         <div class="modal-content">
            <div class="modal-header border-blow">
               <div class="thm-heading">
                  <h3>{{ $t('details','Details') }}</h3>
               </div>
               <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModal()" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="transactionImage-wrap" v-if="transactionImageLists?.length">
                    <div class="transactionImage-item" v-for="(img, iIndex) in transactionImageLists" :key="iIndex">
                        <a :href="img" download target="_blank">
                           <img :src="img" height="100%" width="100px" />
                        </a>
                    </div>
                </div>
               <div class="transactionImage-wrap" v-else>
                  <p class="text-center" style="color: #000;">{{ $t('no-record-found','No Record found') }}</p>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';
import {getWalletHistory, getTransactionStatus} from '../services/walletHistory'
import { defineAsyncComponent } from 'vue';
export default {
    name: 'WalletHistory',
    
    data() {
        return {
            selectedStatus: 'all',
            selectedTransactionType:'all',
            walletHistoryList: '',
            transactionDetails:null,
            select_entries: 20,
            // filterType: '1, 2, zero',
            spinClass: false,
            loading:false,
            formDates:{
                fromDate: '',
                toDate: '',
            },
            options: [
                { label: this.$t('all', 'All'), value: 'all', selected:true },
                { label: this.$t('pending', 'Pending'), value: 'pending', selected:true },
                { label: this.$t('approved', 'Approved'), value: 'approve_completed', selected:true },
                { label: this.$t('rejected', 'Rejected'), value: 'reject_completed', selected:true },
                { label: this.$t('processing', 'Processing'), value: 'processing', selected:true },
                { label: this.$t('expired', 'Expired'), value: 'expired', selected:true },
            ],
            walletHistoryData: null,
            selectedRequest: null
        }
    },
    components: {
        NoDataFound
    },
    created() {
        this.formDates.fromDate = this.$dateTime.getPreviousDate(30)
        this.formDates.toDate = this.$dateTime.getcurrentDate();                      
        this.getWalletHistory();
    },
    computed: {
        filteredWalletHistoryList() {
            if (this.selectedTransactionType === 'all') {
                return this.walletHistoryData;
            }
            else if(this.selectedTransactionType === 'd') {
                return this.walletHistoryData?.filter((item) => ['client_deposit','manual_deposit'].includes(item.type));
            }
            else {
                return this.walletHistoryData?.filter((item) => ['client_withdrawal','manual_withdrawal'].includes(item.type));
            }
        },
        transactionImageLists() {
            return this.transactionDetails?.transaction_image_url?.split(',')
      },
    },
    methods: {
        toTitleCaseWithSpaces(str) {
            return str.split('_')[0] + ' ' + str.split('_')[1] ;
        },
        getTransactionStatus,
        toggleComments(index) {
            this.showComments = { [index]: !this.showComments[index] };
        },
        validateDateFields() {
            const { fromDate, toDate } = this.formDates;
            if (!fromDate || !toDate) {
                if (!fromDate && !toDate) {
                    this.$errorToast("From and To Date Field Is Required.");
                } else if (!fromDate) {
                    this.$errorToast("From Date Field Is Required.");
                } else {
                    this.$errorToast("To Date Field Is Required.");
                }
                return false;
            }
            return true;
        },
        async getWalletHistory(request  = null) {
                try{
                if (!this.validateDateFields()) {
                    return; 
                }
                this.statusData = this.selectedStatus;
                request ? this.spinClass = true : this.$store.dispatch('setGlobalLoader', true);
                this.selectedRequest = request
                let response = await getWalletHistory(this.formDates)
                request ? setTimeout(()=>{this.spinClass = false;} ,500) : this.$store.dispatch('setGlobalLoader', false);
                if(response){
                    this.walletHistoryData = response?.walletHistoryData || [];
                    if(this.selectedStatus == 'all'){
                        this.walletHistoryData = this.walletHistoryData;
                    }
                    else if(this.selectedStatus == 'processing'){
                        this.walletHistoryData = this.walletHistoryData?.filter((history) => ['reject_in_process','approve_in_process','hold'].includes(history.status))
                    }
                    else if(!['all', 'processing'].includes(this.selectedStatus)){
                        this.walletHistoryData = this.walletHistoryData?.filter((history) => history.status == this.selectedStatus)
                    }
                }
            }catch(error) {
                request ? this.spinClass = false : this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.$errorToast(error[0]);
                }
            };
        },
        updateSelectedType(type) {
            this.selectedTransactionType = type;
            this.formDates.fromDate = this.$dateTime.getPreviousDate(30)
            this.formDates.toDate = this.$dateTime.getcurrentDate();  
            this.selectedStatus = 'all'
            this.getWalletHistory()
        },
        transactionalDetails(item){
          this.transactionDetails = item
        },
        closeModal(){
          this.transactionDetails=null
          this.$helper.closeModal('transactionModal')
        },
        preventClearFromDate(event) {
            if (!event.target.value) {
                this.formDates.fromDate = this.$dateTime.getPreviousDate(30); 
            }
        },
        preventClearToDate(event) {
            if (!event.target.value) {
                this.formDates.toDate = this.$dateTime.getcurrentDate();
            }
        },
    },
}
</script>
<style scoped>
.pending {
    border: 1px solid #cf9b00;
    color: #fff;
    border-radius: 4px;
    padding: 0px 5px;
    font-size: 11px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    background: #cf9b00;
}

.reject {
    border: 1px solid #ff0000;
    color: #fff;;
    font-size: 11px;
    padding: 0px 5px;
    border-radius: 4px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    min-width: 70px;
    background: #ff0000;
}

.approved {
    border: 1px solid #28a745;
    color: #fff;
    border-radius: 4px;
    padding: 0px 5px;
    font-size: 11px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    min-width: 70px;
    background: #28a745;
}
.transactionModal{
    cursor:pointer
}
span.transactionModal {
    background: var(--theme-btn-bg);
    color: #fff;
    border: solid 1px var(--theme-btn-bg);
    height: 22px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 4px;
    padding: 0px 4px;
    line-height: 1;
    font-size: 11px;
}
</style>
